/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const OrdersToChainSuppliersPage = lazyLoad(
  () => import('./index'),
  module => module.OrdersToChainSuppliersPage
);
